define.alias("@embroider/util/services/ensure-registered", "media/services/-ensure-registered");